import essApi from "../axios/essApi";

class CertificateService {

    async getCertificate() {
        return Promise.resolve(essApi.get(`user-certificate`));
    }
    async getCertificateById(reqBody) {
      return Promise.resolve(essApi.get(`user-certificate-by-user-id/${reqBody}`));
  }
    async addCertificate(reqBody) {
        return Promise.resolve(essApi.post(`user-certificate`, reqBody));
    }
    async uploadCertificate(files){  
        let formData = new FormData()
        for (const file of files) {
            if (file.type.startsWith('image/')) {
                formData.append('files[]', file);
            } else {
                formData.append('files[]', file);
            }
        }
        const requestConfig = {
            headers: { 'Content-Type': 'multipart/form-data' },
        };
        const response = await essApi.post('uploadFile', formData, requestConfig);
        return Promise.resolve(response);
    }
    async updateCertificate(reqBody) {
        return Promise.resolve(essApi.put(`user-certificate/${reqBody.id}`, reqBody));
    }
    async deleteCertificate(id) {
        return Promise.resolve(essApi.delete(`user-certificate/${id}`));
    }
}

export default CertificateService;
